import React from 'react';
import clsx from 'clsx';

import Typography from 'components/ui/Typography';

import css from './Radio.module.scss';

interface Props extends React.PropsWithChildren {
    disabled?: boolean;
    color?: 'pale' | 'white';
}

const Radio: React.FC<Props & JSX.IntrinsicElements['input']> = ({ children, disabled, color = 'pale', ...rest }) => (
    <label className={clsx(css.label, disabled && css.disabled)}>
        <input type="radio" disabled={disabled} className={css.input} {...rest} />
        <div className={clsx(css.radio, color === 'white' && css.white)}>
            <Typography tag="span" color="inherit" align="center">
                {children}
            </Typography>
        </div>
    </label>
);

export default React.memo(Radio);
